import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SideMenuState {
  isExpanded: boolean;
  isMobileMenuOpen: boolean;
}

const initialState: SideMenuState = {
  isExpanded: true,
  isMobileMenuOpen: false,
};

const sideMenuSlice = createSlice({
  name: "sideMenu",
  initialState,
  reducers: {
    toggleMenu: (state) => {
      state.isExpanded = !state.isExpanded;
    },
    setMenuExpanded: (state, action: PayloadAction<boolean>) => {
      state.isExpanded = action.payload;
    },
    toggleMobileMenu: (state) => {
      state.isMobileMenuOpen = !state.isMobileMenuOpen;
    },
    setMobileMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.isMobileMenuOpen = action.payload;
    },
  },
});

// Exportamos las acciones
export const { toggleMenu, setMenuExpanded, toggleMobileMenu, setMobileMenuOpen } = sideMenuSlice.actions;

// Exportamos el reducer por defecto
export default sideMenuSlice.reducer;
